// extracted by mini-css-extract-plugin
export var active = "ExpandPanel-module--active--7b67a";
export var fadeInAnimation = "ExpandPanel-module--fadeInAnimation--1b492";
export var panel = "ExpandPanel-module--panel--01697";
export var tabList = "ExpandPanel-module--tabList--f5f29";
export var title = "ExpandPanel-module--title--65c99";